








import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import { GChart } from "vue-google-charts";
import ReviewCalculator from "../../lib/reviewCalculator";
import TreeGrid from "../common/TreeGrid2.0.vue";
import moment from "moment";

let _ = require("lodash");

export default Vue.extend({
  name: "ReviewReportCard",
  components: {
    GChart,
    TreeGrid,
  },
  props: {
    review: {
      default: null,
      type: Object,
    },
    valueFormat: {
      default: "both",
      type: String,
    },
  },
  data() {
    return {
      chartRerendered: false,
      aggregatorName: "Average",
      rendererName: "Table Heatmap",
      rows: ["Review Name", "Objective Name", "Assignment Name"],
      cols: ["TargetUser"],
      vals: ["Result"],
      disabledFromDragDrop: ["Review Name"],
      hiddenFromDragDrop: ["Review Name"],
      draggable: ["Review Name"],
      report: null,
      reportData: [],
      nodeExpandCache: {},
      dynamicColumns: [
        {
          title: "Expand / Collapes: Objective & Assignment",
          key: "name",
          sortable: true,
          width: "150",
        },
        {
          title: "Result",
          key: "result",
          width: "150",
        },
      ],
      matchedCheckpoints: [],
      matchedCheckpointsByDay: [],
    };
  },
  computed: {
    ...mapState("review", ["loading", "dateFilter", "targetUserFilter", "trackerFilter", "assessmentFilter", "currentReviewTrackingMembers", "completedCheckpoints", "currentReviewLoadingCount"]),
    notificationText() {
      let context = this as any;
      return context.reportData.length === 0 || !context.reportData[0].children || context.reportData[0].children.length === 0 ? "Hey There! No results have been logged yet!" : null;
    },
  },
  watch: {
    currentReviewLoadingCount(newValue) {
      this.refreshReportData();
    },
    valueFormat(newValue) {
      this.refreshReportData();
    },
  },
  mounted() {},
  methods: {
    refreshReportData() {
      let result = [];
      let context = this as any;
      let review = context.review;
      context.matchedCheckpoints = [];

      if (review && review.objectives) {
        let dataKey = `r_${review.id}`;
        let expand = context.getNodeExpandFromCache(dataKey, true);
        let reviewData = {
          id: review.id,
          name: review.name,
          dataKey: dataKey,
          openNode: expand,
          rowClass: "row-review",
          result: context.formatResult(review.teamTrackingResult),
          selfAverageResult: context.formatResult(review.selfAverageResult),
          otherAverageResult: context.formatResult(review.otherAverageResult),
          averageResult: context.formatResult(review.averageResult),
          children: [],
        };

        if (review.userTrackingResults) {
          review.userTrackingResults.forEach((userTrackingResult) => {
            reviewData[`F_${userTrackingResult.userId}_Self`] = context.formatResult(userTrackingResult.selfResult);
            reviewData[`F_${userTrackingResult.userId}_Other`] = context.formatResult(userTrackingResult.otherResult);
            reviewData[`F_${userTrackingResult.userId}_A`] = context.formatResult(userTrackingResult.averageResult);
          });
        }

        result = [reviewData];

        reviewData.children = review.objectives.map((objective) => {
          let dataKey = `o_${objective.id}`;
          let expand = context.getNodeExpandFromCache(dataKey, false);

          let hasTrackingData = objective.userTrackingResults && objective.userTrackingResults.length > 0;
          let futureObjectiveText = "Future Objective";

          var objectiveData = {
            id: objective.id,
            name: objective.name,
            dataKey: dataKey,
            openNode: expand,
            rowClass: "row-objective",
            result: context.formatResult(objective.teamTrackingResult),
            selfAverageResult: hasTrackingData ? context.formatResult(objective.selfAverageResult) : futureObjectiveText,
            otherAverageResult: hasTrackingData ? context.formatResult(objective.otherAverageResult) : futureObjectiveText,
            averageResult: hasTrackingData ? context.formatResult(objective.averageResult) : futureObjectiveText,
            children: [],
          };

          if (hasTrackingData) {
            objective.userTrackingResults.forEach((userTrackingResult) => {
              objectiveData[`F_${userTrackingResult.userId}_Self`] = context.formatResult(userTrackingResult.selfResult);
              objectiveData[`F_${userTrackingResult.userId}_Other`] = context.formatResult(userTrackingResult.otherResult);
              objectiveData[`F_${userTrackingResult.userId}_A`] = context.formatResult(userTrackingResult.averageResult);
            });
          } else {
            if (context.currentReviewTrackingMembers) {
              context.currentReviewTrackingMembers.forEach((member) => {
                objectiveData[`F_${member.id}_Self`] = futureObjectiveText;
                objectiveData[`F_${member.id}_Self_class`] = "future-objective";
                objectiveData[`F_${member.id}_Other`] = futureObjectiveText;
                objectiveData[`F_${member.id}_Other_class`] = "future-objective";
                objectiveData[`F_${member.id}_A`] = futureObjectiveText;
                objectiveData[`F_${member.id}_A_class`] = "future-objective";
              });
            }

            objectiveData["selfAverageResult_class"] = "future-objective";
            objectiveData["otherAverageResult_class"] = "future-objective";
            objectiveData["averageResult_class"] = "future-objective";
          }

          if (objective.checkpoints) {
            if (objective.historicalCheckpoints && objective.historicalCheckpoints.length > 0) {
              objectiveData.children = _.chain(objective.historicalCheckpoints)
                .groupBy("trackingDateString")
                .map((value, key) => {
                  let matchedTeamCheckpoints = objective.matchedTeamCheckpoints.filter((cp) => cp.trackingDateString === key);
                  let row = {
                    name: key,
                    rowClass: "row-checkpoint",
                    trackingDate: value[0].trackingDate,
                    result: context.formatResult(_.meanBy(matchedTeamCheckpoints, "result")),
                    selfAverageResult: context.formatResult(
                      _.meanBy(
                        value.filter((checkpoint) => checkpoint.targetUserId === checkpoint.trackerId),
                        "result"
                      )
                    ),
                    otherAverageResult: context.formatResult(
                      _.meanBy(
                        value.filter((checkpoint) => checkpoint.targetUserId !== checkpoint.trackerId),
                        "result"
                      )
                    ),
                    averageResult: context.formatResult(_.meanBy(value, "result")),
                  };

                  let test = _.chain(value)
                    .groupBy("targetUserId")
                    .map((value, key) => {
                      return { userId: key, checkpoints: value };
                    })
                    .value()
                    .forEach((target) => {
                      target.checkpoints.forEach((checkpoint) => {
                        let result = context.getCheckpointResult(checkpoint, objective);
                        let columnName = `F_${checkpoint.targetUserId}_${checkpoint.trackerId === checkpoint.targetUserId ? "Self" : "Other"}`;
                        row[columnName] = result.text;
                        row[`${columnName}_class`] = result.class;
                      });

                      let columnName = `F_${target.userId}_A`;
                      row[columnName] = context.formatResult(_.meanBy(target.checkpoints, "result"));
                    });

                  return row;
                })
                .value()
                .sort((a, b) => {
                  return a.trackingDate == b.trackingDate ? 0 : a.trackingDate < b.trackingDate ? 1 : -1;
                });

              context.matchedCheckpoints = context.matchedCheckpoints.concat(objective.historicalCheckpoints);
            }
          }

          return objectiveData;
        });
      }

      context.initDynamicColumns();
      context.generateChartData();

      context.reportData = result;
    },
    initDynamicColumns() {
      if (this.matchedCheckpoints && this.matchedCheckpoints.length > 0) {
        let columns = [
          {
            title: "Review Progress Report",
            key: "name",
            sortable: true,
            align: "left",
            width: "200",
          },
        ];

        if ((this as any).targetUserFilter === 0) {
          let context = this as any;
          let showSelfAverageResult = context.review.gradingOption === 2 && (context.assessmentFilter === "self" || context.assessmentFilter === "both");
          let showOtherAverageResult = (context.review.gradingOption === 2 && (context.assessmentFilter === "other" || context.assessmentFilter === "both")) || context.review.gradingOption === 1;

          if (showSelfAverageResult) {
            columns.push({
              title: `All Team Average\n(${context.review.childRoleName.toLowerCase()} grade)`,
              key: "selfAverageResult",
              sortable: false,
              align: "center",
              width: "120",
            });
          }

          if (showOtherAverageResult) {
            columns.push({
              title: `All Team Average\n(${context.review.parentRoleName.toLowerCase()} grade)`,
              key: "otherAverageResult",
              sortable: false,
              align: "center",
              width: "120",
            });
          }
        }

        if ((this as any).trackerFilter !== 0 || (this as any).currentReviewTrackingMembers.length <= 5) {
          let userColumns = [];
          let targetGroups = _.chain(this.matchedCheckpoints)
            .groupBy("targetUserId")
            .map((value, key) => ({
              targetUserId: key,
              targetUserName: value[0].targetUserName,
              value: value,
              trackers: _.chain(value)
                .groupBy("trackerId")
                .map((value, key) => ({ trackerId: key, trackerName: value[0].trackerName }))
                .value()
                .sort((a, b) => {
                  return a.trackerName == b.trackerName ? 0 : a.trackerName > b.trackerName ? 1 : -1;
                }),
            }))
            .value()
            .sort((a, b) => {
              return a.targetUserName == b.targetUserName ? 0 : a.targetUserName > b.targetUserName ? 1 : -1;
            });

          targetGroups.forEach((targetUser) => {
            let isOnlySelf = targetUser.trackers.length === 1 && targetUser.trackers[0].trackerId === targetUser.targetUserId;

            targetUser.trackers.forEach((tracker) => {
              let assignmentType = tracker.trackerId !== targetUser.targetUserId ? `${this.review.parentRoleName.toLowerCase()} grade` : `${this.review.childRoleName.toLowerCase()} grade`;

              userColumns.push({
                title: `${targetUser.targetUserName}\n(${assignmentType})`,
                key: `F_${targetUser.targetUserId}_${tracker.trackerId === targetUser.targetUserId ? "Self" : "Other"}`,
                sortable: false,
                align: "center",
                width: "120",
              });

              //if (!isOneRoleModel && (this as any).assessmentFilter === "both" && tracker.trackerId !== targetUser.targetUserId) {
              //  columns.push({
              //    title: `${targetUser.targetUserName.toUpperCase()}\n(both averaged)`,
              //    key: `F_${targetUser.targetUserId}_A`,
              //    sortable: false,
              //    align: "center",
              //    width: "120"
              //  });
              //}
            });
          });

          columns = columns.concat(
            userColumns.sort((a, b) => {
              return a.key === b.key ? 0 : a.key < b.key ? 1 : -1;
            })
          );
        } else {
          //if (showSelfAverageResult && (this as any).assessmentFilter === "both") {
          //  columns.push({
          //    title: "All Team Average\n(both averaged)",
          //    key: "averageResult",
          //    sortable: false,
          //    align: "center",
          //    width: "120"
          //  });
          //}
        }

        this.dynamicColumns = columns;
      } else {
        this.dynamicColumns = [];
        console.info("no columns");
      }
    },
    getColumnTitle(targetUserName, trackerName) {},
    generateChartData() {
      let objectives = [...new Set(this.matchedCheckpoints.map((item) => item.objectiveName))];
      objectives = objectives.sort((a, b) => {
        return a == b ? 0 : a > b ? 1 : -1;
      });

      let rows = [["Name", ...objectives]];

      let dateGroupedData = _.chain(this.matchedCheckpoints)
        .groupBy("trackingDate")
        .map((value, key) => ({ date: key, checkpoints: value }))
        .value()
        .sort((a, b) => {
          return a.date == b.date ? 0 : a.date > b.date ? 1 : -1;
        });

      dateGroupedData.forEach((dateGroup) => {
        rows.push([moment(dateGroup.date).format("ll"), ...this.getRowData(objectives, dateGroup.checkpoints)]);
      });
    },
    getRowData(objectives, checkpoints) {
      let objectiveValues = _.chain(checkpoints)
        .groupBy("objectiveName")
        .map((value, key) => ({ objectiveName: key, value: _.meanBy(value, "result") }))
        .value();
      let objectivesHaveData = [...new Set(objectiveValues.map((item) => item.objectiveName))];

      objectiveValues = objectiveValues.concat(objectives.filter((objective) => !objectivesHaveData.includes(objective)).map((item) => ({ objectiveName: item, value: NaN }))).sort((a, b) => {
        return a.objectiveName == b.objectiveName ? 0 : a.objectiveName > b.objectiveName ? 1 : -1;
      });

      return objectiveValues.map((objective) => objective.value);
    },
    groupBy(xs, key) {
      let result = xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});

      return Object.keys(result).map((key) => {
        return { key: key, items: result[key] };
      });
    },
    formatResult(result) {
      if (isNaN(result) || result === null) {
        return "";
      } else {
        return Math.round(result * 100) + "%";
      }
    },
    getCheckpointResult(checkpoint, objective) {
      let valueFormat = this.valueFormat;
      if (isNaN(checkpoint.value) || checkpoint.value === null) {
        let endOfToday = new Date();
        endOfToday.setHours(23, 59, 59, 999);
        let startOfToday = new Date();
        startOfToday.setHours(0, 0, 0, 0);
        let trackingDate = new Date(checkpoint.trackingDate);

        return trackingDate >= new Date() && trackingDate <= endOfToday
          ? { text: "Due Today", class: "checkpoint-due-today" }
          : { text: valueFormat === "values" ? "Overdue" : "Overdue\n(0%)", class: "checkpoint-overdue" };
      } else {
        let grades = "";

        if (objective.targetType === 1) {
          grades = `${this.formatNumber(checkpoint.value)} ${objective.measurementUnit}`;
        } else if (objective.targetType === 2 && objective.inputOptions) {
          let inputOptions = JSON.parse(objective.inputOptions);
          let options = (inputOptions as any).filter((option) => option.value == checkpoint.value);
          if (options.length > 0) {
            grades = options[0].label;
          }
        }

        return {
          text: valueFormat === "both" ? `${grades}\n(${this.formatResult(checkpoint.result)})` : valueFormat === "values" ? grades : this.formatResult(checkpoint.result),
          class: "checkpoint-normal",
        };
      }
    },
    handleNodeToggleExpand(node) {
      if (node.dataKey) {
        this.nodeExpandCache[node.dataKey] = node.expanded;
      }
    },
    getNodeExpandFromCache(dataKey, defaultValue) {
      return this.nodeExpandCache[dataKey] === undefined ? defaultValue : this.nodeExpandCache[dataKey];
    },
    formatNumber(num) {
      if (!num) {
        return "";
      } else if (num && `${num}`.includes(".")) {
        return `${num}`.toString().replace(/(\d)(?=(\d{3})+\.)/g, function ($1, $2) {
          return $2 + ",";
        });
      } else {
        return `${num}`.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
});
